import { useState } from "react";
import { gold, w } from "../constants";
import { ScriptureBar } from "../components";
import SpiritualGiftsModule from "../modules/SpiritualGiftsModule";
import DISCModule from "../modules/DISCModule";
import BudgetModule from "../modules/BudgetModule";
import BiblePlanModule from "../modules/BiblePlanModule";
import FitnessModule from "../modules/FitnessModule";

const MODULE_REGISTRY = [
  {
    id:"spiritual_gifts", title:"Spiritual Gifts Assessment",
    description:"Discover your God-given gifts across Romans 12, 1 Corinthians 12, and Ephesians 4.",
    icon:"🎁", color:"#1A56DB", component:SpiritualGiftsModule, available:true,
  },
  {
    id:"disc", title:"DISC Personality Profile",
    description:"Understand how you are wired — how you lead, relate, and work with others.",
    icon:"🧠", color:"#7E3AF2", component:DISCModule, available:true,
  },
  {
    id:"budget", title:"Personal Budget",
    description:"Monthly budget tracking with annual rollup — income, giving, saving, and spending.",
    icon:"💰", color:"#057A55", component:BudgetModule, available:true,
  },
  {
    id:"bible_plan", title:"Bible Reading Plan",
    description:"Choose a plan and track your daily Bible reading with streak tracking.",
    icon:"📖", color:"#D97706", component:BiblePlanModule, available:true,
  },
  {
    id:"fitness", title:"Personal Fitness Tracker",
    description:"Weekly habit tracker for exercise, nutrition, sleep, and hydration.",
    icon:"💪", color:"#E02424", component:FitnessModule, available:true,
  },
];

// To add a new module in future:
// 1. Create src/modules/YourModule.js
// 2. import YourModule from "../modules/YourModule"
// 3. Add one entry to MODULE_REGISTRY above
// App.js never needs to change.

export default function ModulesTab({ data, saveData, userName }) {
  const [activeModule, setActiveModule] = useState(null);
  const moduleData = data.modules||{};

  const handleSave = (moduleId, updated) => {
    const d = JSON.parse(JSON.stringify(data));
    if(!d.modules) d.modules={};
    d.modules[moduleId] = updated;
    saveData(d);
  };

  if(activeModule) {
    const mod = MODULE_REGISTRY.find(m=>m.id===activeModule);
    const ModComponent = mod.component;
    return <ModComponent moduleData={moduleData[activeModule]} onSave={updated=>handleSave(activeModule,updated)} onBack={()=>setActiveModule(null)} userName={userName} />;
  }

  return (
    <div>
      <h2 style={{ fontSize:18,fontWeight:500,margin:"0 0 4px",color:w.text }}>Modules</h2>
      <p style={{ fontSize:13,color:w.text2,margin:"0 0 16px" }}>Focused tools to help you grow in specific areas of your life and calling.</p>
      <ScriptureBar section="modules" />
      <div style={{ display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(280px,1fr))",gap:12 }}>
        {MODULE_REGISTRY.map(mod=>{
          const attempts=moduleData[mod.id]?.attempts?.length||0;
          const hasData=!!moduleData[mod.id];
          return (
            <div key={mod.id} onClick={()=>mod.available&&setActiveModule(mod.id)}
              style={{ background:w.bg,border:`0.5px solid ${w.border}`,borderRadius:12,padding:"20px",cursor:mod.available?"pointer":"default",opacity:mod.available?1:0.6,transition:"border-color 0.15s,transform 0.1s" }}
              onMouseEnter={e=>{ if(mod.available){e.currentTarget.style.borderColor=mod.color;e.currentTarget.style.transform="translateY(-1px)";} }}
              onMouseLeave={e=>{ e.currentTarget.style.borderColor=w.border;e.currentTarget.style.transform="translateY(0)"; }}>
              <div style={{ display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:12 }}>
                <div style={{ width:44,height:44,borderRadius:10,background:`${mod.color}20`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:22 }}>{mod.icon}</div>
                {mod.available
                  ? <span style={{ fontSize:11,padding:"3px 10px",background:`${mod.color}15`,color:mod.color,borderRadius:20,fontWeight:500 }}>Available</span>
                  : <span style={{ fontSize:11,padding:"3px 10px",background:w.bg2,color:w.text3,borderRadius:20 }}>Coming soon</span>
                }
              </div>
              <h3 style={{ fontSize:15,fontWeight:500,color:w.text,margin:"0 0 6px" }}>{mod.title}</h3>
              <p style={{ fontSize:13,color:w.text2,lineHeight:1.6,margin:"0 0 12px" }}>{mod.description}</p>
              {hasData&&attempts>0&&<p style={{ fontSize:12,color:mod.color,margin:0,fontWeight:500 }}>{attempts} attempt{attempts!==1?"s":""} completed</p>}
              {hasData&&attempts===0&&<p style={{ fontSize:12,color:"#057A55",margin:0 }}>In progress</p>}
              {!hasData&&mod.available&&<p style={{ fontSize:12,color:w.text3,margin:0 }}>Not started yet</p>}
            </div>
          );
        })}
      </div>
    </div>
  );
}
